export const mattressTypes = [
  {
    value: "foam",
    text: "Foam(+40)",
    priceToAdd: 40,
  },
  {
    value: "Orthopaedic",
    text: "Orthopaedic",
    priceToAdd: 0,
  },
  {
    value: "Pocket Sprung",
    text: "Pocket Sprung(+100)",
    priceToAdd: 100,
  },
];
export const fabrics = [
  {
    text: "Plush Velvel",
    value: "plush",
    colors: [
      "Steel",
      "Silver",
      "Grey",
      "Black",
      "Mustard Blue",
      "Duck Egg",
      "Biege",
      "Teal",
      "Saphire",
      "Maroon",
    ],
  },
  {
    text: "Crush Velvet",
    value: "cursh",
    colors: [
      "White",
      "Silver",
      "Grey",
      "Cream",
      "Champagne",
      "Gold",
      "Milk",
      "Brown",
      "Teal",
      "Denim Blue",
      "Red",
      "Black",
    ],
  },
  {
    text: "Naple",
    value: "naple",
    colors: [
      "Cream",
      "Mink",
      "Brown",
      "Seal Silver",
      "Silver",
      "Charcoal",
      "Teal",
      "Blue",
      "Purple",
      "Black",
    ],
  },
  {
    text: "Chenil",
    value: "chenil",
    colors: [
      "Cream",
      "Mink",
      "Chocolate",
      "Silver",
      "Charcoal",
      "Duck Egg",
      "Teal",
      "Purple",
      "Burgundy",
      "Red",
    ],
  },
];

export const depths = [
  {
    text: "8",
    value: "8",
    priceToAdd: 0,
  },
  {
    text: "9",
    value: "9",
    priceToAdd: 0,
  },
  {
    text: "10",
    value: "10",
    priceToAdd: 0,
  },
  {
    text: "11",
    value: "11",
    priceToAdd: 0,
  },
  {
    text: "12 (+20)",
    value: "12",
    priceToAdd: 20,
  },
];

export const bds = ["Buttons", "Diamonds"];

export const API_URL = "https://bleepsleep-server.herokuapp.com/api";
// export const API_URL = " http://localhost:5000/api";

export const sampleProducts = [
  {
    _id: "606d909b3f2ad40af8a497ceimages",
    images: [
      "https://firebasestorage.googleapis.com/v0/b/ecommerse-f3062.appspot.com/o/IMG-20210406-WA0015.jpg?alt=media&token=31d975db-60ca-45db-8b24-cff5f8496d1e",
      "https://firebasestorage.googleapis.com/v0/b/ecommerse-f3062.appspot.com/o/IMG-20210406-WA0016.jpg?alt=media&token=64fb6cf3-6612-4da1-8759-bef52d183bde",
      "https://firebasestorage.googleapis.com/v0/b/ecommerse-f3062.appspot.com/o/IMG-20210406-WA0017.jpg?alt=media&token=97525297-f863-4596-b413-c1bdcaaa1ac6",
      "https://firebasestorage.googleapis.com/v0/b/ecommerse-f3062.appspot.com/o/IMG-20210406-WA0018.jpg?alt=media&token=dfd8357b-d7a5-405a-b9f8-0b20ae4fc0b8",
    ],
    name: "Sleigh Bed",
    availability: "available",
    catagory: "beds",
    description:
      "Luxury Tufted Button Diamond Pattern Upholstered Headboard Sleigh Beds Available with free delivery.",
    others: {
      sizes: [
        {
          text: "Single 3ft",
          value: "Single 3ft",
          price: "200",
          mattressPrice: "250",
        },
        {
          text: "Small Double 4ft",
          value: "Small Double 4ft",
          price: "220",
          mattressPrice: "280",
        },
        {
          text: "Regular Double 4ft6'",
          value: "Regular Double 4ft6'",
          price: "220",
          mattressPrice: "280",
        },
        {
          text: "King 5ft",
          value: "King 5ft",
          price: "240",
          mattressPrice: "300",
        },
        {
          text: "Supreme King 6ft",
          value: "Supreme King 6ft",
          price: "280",
          mattressPrice: "350",
        },
      ],
    },
  },
];

export const drawers = [
  {
    text: "No Drawers",
    value: "No Drawers",
    priceToAdd: 0,
  },
  {
    text: "One Drawer on Right Side(+20)",
    value: "One Drawer on Right Side(+20)",
    priceToAdd: 20,
  },
  {
    text: "One Drawer on Left Side(+20)",
    value: "One Drawer on Left Side(+20)",
    priceToAdd: 20,
  },
  {
    text: "Two Drawers on Right Side(+40)",
    value: "Two Drawers on Right Side(+40)",
    priceToAdd: 40,
  },
  {
    text: "Two Drawers on Left Side(+40)",
    value: "Two Drawers on Left Side(+40)",
    priceToAdd: 40,
  },
  {
    text: "One Drawer on each Side(+40)",
    value: "One Drawer on each Side(+40)",
    priceToAdd: 40,
  },
  {
    text: "Two Drawers on each Side(+80)",
    value: "Two Drawers on each Side(+80)",
    priceToAdd: 80,
  },
];

export const sofaTypes = ["Corner Sofa", "2 + 3 Seater"];
